"use client";

import { Menu } from "lucide-react";
import { useTranslations } from "next-intl";

import { useNav } from "@/components/nav/NavProvider";
import { cn } from "@/lib/utils";

interface HamburgerButtonProps {
  className?: string;
}

// Opens the AppDrawer. Use in any page header that needs the trigger
// (the new placeholder pages do; DesktopRail covers desktop without it).
export function HamburgerButton({ className }: HamburgerButtonProps) {
  const { openDrawer } = useNav();
  const t = useTranslations("nav");

  return (
    <button
      type="button"
      aria-label={t("openDrawer")}
      onClick={openDrawer}
      className={cn(
        "inline-flex size-10 cursor-pointer items-center justify-center rounded-md border border-border bg-input-bg text-foreground transition-colors hover:bg-secondary-dark",
        className
      )}
    >
      <Menu className="size-5" aria-hidden />
    </button>
  );
}
